/* Quickshop: fetch the product's quickshop-content section into the modal. */
(function () {
  'use strict';
  /* Secties nemen dit bestand elk zelf op, dus staat het soms twee of drie keer
     op één pagina. De browser voert elke tag dan opnieuw uit, waardoor listeners
     op document dubbel hangen en één klik twee acties uitvoert. Deze poort laat
     alleen de eerste uitvoering door. */
  window.__hwsLoaded = window.__hwsLoaded || {};
  if (window.__hwsLoaded['component_quickshop']) return;
  window.__hwsLoaded['component_quickshop'] = true;

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-quickshop-open]');
    if (!trigger) return;
    var modal = document.getElementById('QuickShop');
    if (!modal || !window.fetch) return;
    event.preventDefault();
    var url = trigger.getAttribute('data-product-url');
    if (!url) return;
    var body = modal.querySelector('[data-quickshop-body]');
    var skeleton = modal.querySelector('[data-quickshop-skeleton]');
    var error = modal.querySelector('[data-quickshop-error]');
    var existing = body.querySelector('[data-quickshop-content]');
    if (existing) existing.remove();
    if (skeleton) skeleton.hidden = false;
    if (error) error.hidden = true;
    window.hwsOverlay.open('QuickShop', trigger);
    var separator = url.indexOf('?') === -1 ? '?' : '&';
    fetch(url + separator + 'section_id=quickshop-content')
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var parsed = new DOMParser().parseFromString(text, 'text/html');
        var content = parsed.querySelector('[data-quickshop-content]');
        if (!content) throw new Error('no content');
        if (skeleton) skeleton.hidden = true;
        body.appendChild(content);
        var focusable = content.querySelector('button, a, select, input');
        if (focusable) focusable.focus();
      })
      .catch(function () {
        if (skeleton) skeleton.hidden = true;
        if (error) error.hidden = false;
      });
  });
})();
